import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ThemeContext from '../../theme/ThemeContext';

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 6px;
  border-radius: ${(props) => (props.$explicit ? 7 : 30)}px; // just a high number to create pill effect
  background-color: ${(props) => props.theme.secondaryColor};
  min-width: ${(props) => props.$tabWidth * 2}px;

  * {
    z-index: 2;
  }

`;

const StyledTabs = styled.div`
  display: flex;
  position: relative;
`;

const StyledTabLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${(props) => (props.$explicit ? 7 : 30)}px;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  color: ${(props) => props.theme.fontColorSecondary};

  &.active, &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.fontColorPrimary};
  }

  &.active, &:hover {
    cursor: pointer;
    svg {
      color: ${(props) => props.theme.fontColorPrimary};
    }
  }
`;

const StyledGlider = styled.span`
  position: absolute;
  display: flex;
  z-index: 1;
  border-radius: ${(props) => (props.$explicit ? 5 : 30)}px;
  transition: 0.15s ease-out;
  background-color: ${(props) => props.theme.backgroundColor};

  ${(props) => {

    let styles = '';

    props.$tabs.forEach((tab, i) => {
      styles += `
        &.active-${i} {
          transform: translateX(${props.$tabWidth * i}px);
        }
      `;
    });

    return styles;

  }}
`;

const StyledIcon = styled.span`
  padding-right: 4px;
  svg {
    transition: all 0.15s ease-in-out;
  }
`;

const TabSlider = ({
  onChange,
  tabs,
  tabWidth,
  tabHeight,
  tabStyles,
  explicit,
  defaultTab
}) => {

  const theme = useContext(ThemeContext);
  const [active, setActive] = useState(defaultTab || 0);

  const TabNodes = tabs.map(({ id, icon, iconSize }, i) => {

    const body = icon && (
      <StyledIcon theme={theme}>
        <FontAwesomeIcon icon={icon} size={iconSize} />
      </StyledIcon>
    );

    return (
      <StyledTabLabel
        theme={theme}
        key={i}
        className={active === i ? 'active' : ''}
        $explicit={explicit}
        style={{
          width: tabWidth,
          height: tabHeight,
          ...tabStyles,
        }}
        onClick={() => {
          setActive(i);
          if (onChange) onChange(id);
        }}
      >
        {body}
        {' '}
        {explicit && id}
      </StyledTabLabel>
    );
  });

  return (
    <StyledWrapper theme={theme} $tabWidth={tabWidth} $explicit={explicit}>
      <StyledTabs>
        {TabNodes}
        <StyledGlider
          theme={theme}
          $explicit={explicit}
          className={`glider active-${active}`}
          style={{
            width: tabWidth,
            height: tabHeight,
          }}
          $tabs={tabs}
          $tabWidth={tabWidth}
        />
      </StyledTabs>
    </StyledWrapper>
  );
};

export default React.memo(TabSlider);
